import React from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Box,
  Skeleton,
  SxProps,
  Theme,
  Card,
  CardActionArea,
} from "@mui/material";
import { exerciseLibraryStyles } from "../exercise-library/exerciseLibraryStyles";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { getComponentTemplateLibraryWidths } from "../component-templates-library/ComponentTemplateLibrary";

interface SkeletonLoaderProps {
  width?: string | number;
  height?: number;
  variant?: "text" | "circular" | "rectangular";
  sx?: SxProps<Theme>;
}
const useStyles = makeStyles((theme) => ({
  actionArea: {
    padding: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
    },
    gap: theme.spacing(2),
    justifyContent: "start",
  },

  textContainer: {
    width: "60%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
}));

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  width = "60%",
  height = 20,
  variant = "text",
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Skeleton variant={variant} width={width} height={height} sx={sx} />
    </Box>
  );
};

interface ComponentTemplateLibraryTableSkeletonProps {
  loading?: boolean;
  className?: string;
}

export const ComponentTemplateLibraryTableSkeleton: React.FC<
  ComponentTemplateLibraryTableSkeletonProps
> = ({ className }) => {
  const columnWidths = getComponentTemplateLibraryWidths();
  return (
    <TableBody className={className}>
      <TableRow hover>
        <TableCell
          component="th"
          scope="row"
          sx={{ width: columnWidths.thumbnail }}
        >
          <SkeletonLoader
            variant="circular"
            width={160}
            height={86}
            sx={{ borderRadius: 2, justifyContent: "flex-start" }}
          />
        </TableCell>

        <TableCell
          component="th"
          scope="row"
          sx={{ width: columnWidths.title }}
        >
          <Box sx={{ width: "80%" }}>
            <Skeleton width={"80%"} />
            <Skeleton width={"100%"} />
          </Box>
        </TableCell>

        <TableCell align="center" sx={{ width: columnWidths.category }}>
          <SkeletonLoader width="60%" />
        </TableCell>

        <TableCell align="center" sx={{ width: columnWidths.type }}>
          <SkeletonLoader width="60%" />
        </TableCell>

        <TableCell align="center" sx={{ width: columnWidths.actions }}>
          <SkeletonLoader width="60%" />
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

interface ComponentTemplateLibraryCardSkeletonProps {
  className?: string;
}

export const ComponentTemplateLibraryCardSkeleton: React.FC<
  ComponentTemplateLibraryCardSkeletonProps
> = ({ className }) => {
  const s = exerciseLibraryStyles();
  const styles = useStyles();
  return (
    <Card className={clsx(s.mobileCard, className)}>
      <CardActionArea className={styles.actionArea}>
        <Box className={styles.textContainer}>
          <Skeleton width="80%" height={22} sx={{ mb: 1 }} />
          <Skeleton width="100%" height={18} />
          <Skeleton width="60%" height={18} sx={{ mt: 1 }} />
        </Box>
      </CardActionArea>
    </Card>
  );
};
